import { useEffect } from "react";
import { useHistoryStore } from "../../stores/history-store";

const editableTags = ["INPUT", "TEXTAREA", "SELECT"];

export function isEditingText(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  return editableTags.includes(target.tagName);
}

export function useHistoryShortcuts() {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const hasModifier = event.ctrlKey || event.metaKey;
      if (!hasModifier) return;
      const key = event.key.toLowerCase();
      const isUndo = key === "z" && !event.shiftKey;
      const isRedo = (key === "z" && event.shiftKey) || key === "y";
      if (!isUndo && !isRedo) return;
      if (event.isComposing) return;
      event.preventDefault();
      const history = useHistoryStore.getState();
      if (isUndo) history.undo();
      else history.redo();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);
}
